function navSearch() {
    $('body').on('click', '.searchIcon', function () {
        $('.nav-search').addClass('open-search');
      $('li.search-bar').addClass('active-bar');
    });
    $('body').on('click', '#hide-search', function () {
        $('.nav-search').removeClass('open-search');
      $('li.search-bar').removeClass('active-bar');
    });
}
navSearch();

var $container = $(".nav-search");
if ($container.length) {
  $(document).bind("mouseup touchend", function (e) {
    if (!$container.is(e.target) && $container.has(e.target).length === 0) {
      $(".nav-search").removeClass("open-search");
      $('li.search-bar').removeClass('active-bar');
    }
  });
}
